module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Book.523cf5c2.otf";